import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, UncontrolledAlert } from "reactstrap";
import { Button } from "zina-dogi-react";
import { Formik, Form, Field } from "formik";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { service as oetService } from "../../oet/redux";
import { utils } from "~/utils";

export default class FilterSSOTItemModal extends Component {
    constructor(props) {
        super(props);
        this.data = null;
        this.state = {
            modal: false,
            field_site_ids: [],
            inputValueSite: "",
            field_material_type: null,
            list_code_not_found: []
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({ modal: !this.state.modal });
    }

    cleanSiteNotFound = () => {
        this.setState({ list_code_not_found: [] });
    };

    onSubmit = (values, formik) => {
        this.props.parentComponent.setState({ ids: [] });
        this.props.parentComponent.resetSelectedRows();
        const site_ids = values.site_ids ? values.site_ids.map(val => val.value) : null;
        const material_type = values.material_type ? values.material_type.value : null;
        this.setState({
            field_site_ids: values.site_ids,
            field_material_type: values.material_type
        });
        this.props.updateData(1, site_ids, material_type);
        formik.setSubmitting(false);
        this.toggle();
    };

    loadOptions = (val, formik) => {
        const search_list = val ? utils.splitText(val) : [val];
        if (search_list.length > 1) {
            let new_search_list =
                formik.values && formik.values.site_ids && formik.values.site_ids.length
                    ? search_list.concat(
                          formik.values.site_ids.map(item => {
                              return item.label;
                          })
                      )
                    : search_list;
            new_search_list = new_search_list.filter(val => val);
            oetService
                .getOETSitesAutoComplete(this.props.oet.id, this.props.run.id, null, new_search_list)
                .then(resp => {
                    const site_list = resp.map(site => {
                        return {
                            value: site.id,
                            label: site.customer_site_code
                        };
                    });
                    const customer_site_code_list = resp.map(site => site.customer_site_code);
                    const list_code_not_found = new_search_list.filter(x => customer_site_code_list.indexOf(x) < 0);
                    if (list_code_not_found && list_code_not_found.length > 0) {
                        this.setState({ list_code_not_found });
                    } else {
                        this.cleanSiteNotFound();
                    }
                    if (site_list.length > 0) {
                        this.setState({ inputValueSite: "" });
                        formik.setFieldValue("site_ids", site_list, false);
                        return site_list;
                    }
                });
        }
        return oetService.getOETSitesAutoComplete(this.props.oet.id, this.props.run.id, val).then(resp => {
            return resp.map(val => {
                return { value: val.id, label: val.customer_site_code };
            });
        });
    };

    render() {
        const options = [
            { value: "ni", label: "NI" },
            { value: "npo", label: "NPO" }
        ];
        return (
            <div>
                <Modal isOpen={this.state.modal} toggle={this.toggle} size="xl" centered>
                    <ModalHeader>Filter Item</ModalHeader>
                    <ModalBody>
                        <div>
                            {this.state.list_code_not_found.length > 0 && (
                                <UncontrolledAlert color="danger" toggle={this.cleanSiteNotFound}>
                                    <b>Site ID not found: </b> {this.state.list_code_not_found.join(", ")}
                                </UncontrolledAlert>
                            )}
                            <Formik
                                className="filter-ssot-item-modal"
                                initialValues={{
                                    site_ids: this.state.field_site_ids,
                                    material_type: this.state.field_material_type
                                }}
                                onSubmit={this.onSubmit}
                            >
                                {formik => (
                                    <Form className="form">
                                        <div className="fields">
                                            <Row>
                                                <Col>
                                                    <div className="form-group">
                                                        <label>Site ID</label>
                                                        <Field
                                                            name="site_ids"
                                                            value={formik.values.site_ids}
                                                            component={AsyncSelect}
                                                            isClearable
                                                            className="basic-multi-select"
                                                            isMulti
                                                            cacheOptions
                                                            defaultOptions
                                                            inputValue={this.state.inputValueSite}
                                                            loadOptions={val => this.loadOptions(val, formik)}
                                                            onInputChange={val => {
                                                                this.setState({ inputValueSite: val });
                                                                return val;
                                                            }}
                                                            onChange={val => {
                                                                formik.setFieldValue("site_ids", val, false);
                                                            }}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <div className="form-group">
                                                        <label>Material Type</label>
                                                        <Field
                                                            name="material_type"
                                                            value={formik.values.material_type}
                                                            isClearable
                                                            className="basic-single"
                                                            component={Select}
                                                            options={options}
                                                            onChange={val =>
                                                                formik.setFieldValue("material_type", val, false)
                                                            }
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div>
                                                <Button
                                                    type="submit"
                                                    color="primary"
                                                    style={{ width: "175px" }}
                                                    className="mr-1"
                                                >
                                                    Submit
                                                </Button>
                                                <Button
                                                    className="btn-danger mr-1"
                                                    onClick={this.toggle}
                                                    type="button"
                                                    name="Close"
                                                    style={{ width: "175px" }}
                                                >
                                                    Close
                                                </Button>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}
